import React from "react";

// Las capturas se guardaron a resolución completa de pantalla del celular.
// Insertamos una transformación de Cloudinary (formato + calidad automática,
// resize a un ancho razonable para el contenedor) para que carguen rápido
// sin tener que re-subir ni recortar nada manualmente.
const withFastLoad = (url) =>
  url.replace("/upload/", "/upload/f_auto,q_auto,w_800,c_limit/");

const SCREENSHOTS = {
  home: withFastLoad(
    "https://res.cloudinary.com/dbvqeiqxb/image/upload/v1790306286/Screenshot_2026-09-24_at_9.41.18_PM_dchmmi.png"
  ),
  categories: withFastLoad(
    "https://res.cloudinary.com/dbvqeiqxb/image/upload/v1790306286/Screenshot_2026-09-24_at_9.42.21_PM_anjypl.png"
  ),
  category: withFastLoad(
    "https://res.cloudinary.com/dbvqeiqxb/image/upload/v1790306286/Screenshot_2026-09-24_at_9.43.15_PM_hufol6.png"
  ),
  confirm: withFastLoad(
    "https://res.cloudinary.com/dbvqeiqxb/image/upload/v1790306286/Screenshot_2026-09-24_at_9.44.18_PM_rzl0ij.png"
  ),
};

const Step = ({ number, children, screenshotSrc, screenshotAlt }) => (
  <li className="mb-5">
    <div className="flex gap-2">
      <span className="font-bold text-brand-primary">{number}.</span>
      <div className="flex-1">{children}</div>
    </div>
    {screenshotSrc && (
      <img
        src={screenshotSrc}
        alt={screenshotAlt}
        className="mt-2 w-full rounded-xl border border-violet-300"
      />
    )}
  </li>
);

// Campañas por web: los pasos vienen del JSON (**negritas** con asteriscos).
const renderBold = (text) =>
  text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
    i % 2 ? (
      <strong key={i} className="text-brand-dark">
        {part}
      </strong>
    ) : (
      part
    )
  );

const WebSteps = ({ steps }) => (
  <div className="text-left">
    <ol className="list-none">
      {steps.map((step, i) => (
        <Step key={i} number={i + 1}>
          {renderBold(step)}
        </Step>
      ))}
      <li>
        <div className="rounded-xl px-4 py-3 text-center font-semibold bg-violet-300/[0.12] text-brand-primary">
          🎉 ¡Listo! Gracias por apoyar a Kari.
        </div>
      </li>
    </ol>
  </div>
);

const StepByStepGuide = ({ categories, steps }) => {
  if (steps?.length) return <WebSteps steps={steps} />;
  const [firstCategory, ...restCategories] = categories;

  return (
    <div className="text-left">
      <ol className="list-none">
        <Step number={1}>
          Abre la app y{" "}
          <strong className="text-brand-dark">
            regístrate o inicia sesión
          </strong>
          .
        </Step>

        <Step
          number={2}
          screenshotSrc={SCREENSHOTS.home}
          screenshotAlt="Botón 'Vota por tu artista favorito' en la pantalla principal de la app"
        >
          Pica en{" "}
          <strong className="text-brand-dark">
            "Vota por tu artista favorito"
          </strong>
          .
        </Step>

        <Step
          number={3}
          screenshotSrc={SCREENSHOTS.categories}
          screenshotAlt="Lista de categorías de los HEAT Awards"
        >
          Busca las categorías:
          <ul className="list-disc list-inside mt-1">
            {categories.map((cat) => (
              <li key={cat.name} className="text-brand-dark">
                {cat.name}
              </li>
            ))}
          </ul>
        </Step>

        {firstCategory && (
          <Step
            number={4}
            screenshotSrc={SCREENSHOTS.category}
            screenshotAlt={`Deslizando en ${firstCategory.name} hasta encontrar a ${firstCategory.nominee}`}
          >
            Entra a{" "}
            <strong className="text-brand-dark">{firstCategory.name}</strong>.
            Desliza hasta encontrar{" "}
            <strong className="text-brand-dark">{firstCategory.nominee}</strong>{" "}
            y pica sobre ella.
          </Step>
        )}

        <Step
          number={5}
          screenshotSrc={SCREENSHOTS.confirm}
          screenshotAlt="Popup de confirmación de voto"
        >
          Acepta el popup de confirmación.
        </Step>

        {restCategories.map((cat, i) => (
          <Step key={cat.name} number={6 + i}>
            Repite exactamente el mismo proceso para{" "}
            <strong className="text-brand-dark">{cat.name}</strong> y selecciona{" "}
            <strong className="text-brand-dark">{cat.nominee}</strong>.
          </Step>
        ))}

        <li>
          <div className="flex gap-2">
            <span className="font-bold text-brand-primary">
              {6 + restCategories.length}.
            </span>
            <div className="flex-1 rounded-xl px-4 py-3 text-center font-semibold bg-violet-300/[0.12] text-brand-primary">
              🎉 ¡Listo! Gracias por apoyar a Kari.
              <br />
              <span className="font-normal text-sm text-gray-500">
                Recuerda regresar mañana para volver a votar.
              </span>
            </div>
          </div>
        </li>
      </ol>
    </div>
  );
};

export default StepByStepGuide;
